import { EditableContext } from "../../common/EditableContextProvider";
import { useContext, useRef } from "react";
import { Table } from "antd";
import dayjs from "dayjs";
import { sprintf } from "sprintf-js";
const { Column } = Table;

export const TableComponent = () => {
    const { casos, pagos, documentos } = useContext(EditableContext);
    const searchInput = useRef(null);

    const ActionButtons = ({ item }) => {
        return (
            <>
                <button className="btn btn-sm btn-action btn-light border py-0" title="Editar"
                    onClick={() => casos.selectItem(item)}>
                    <span className="fas fa-pen text-sm" style={{ fontSize: '0.85em' }}></span>
                </button>
                <button className="btn btn-sm btn-action btn-light border py-0 ms-1" title="Eliminar"
                    onClick={() => casos.handle_delete(item)}>
                    <span className="fas fa-trash text-sm" style={{ fontSize: '0.85em' }}></span>
                </button>
            </>
        );
    }
    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div className="p-1" onKeyDown={e => e.stopPropagation()}>
                <input type="text" className="form-control form-control-sm"
                    ref={searchInput}
                    placeholder='Escribe algo...'
                    value={(selectedKeys[0]) ? selectedKeys[0] : ""}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onKeyUp={(e) => {
                        if (e.key === 'Enter') { handleSearch(selectedKeys, confirm, dataIndex) }
                    }}
                />
                <div className="mt-1 d-flex justify-content-center">
                    <button className="btn btn-sm btn-light border mx-1"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    >
                        <span className="fas fa-search"></span>
                    </button>

                    <button className="btn btn-sm btn-light border mx-1"
                        onClick={() => clearFilters && handleReset(clearFilters, setSelectedKeys, confirm)}
                    >
                        Reset
                    </button>

                    <button className="btn btn-sm btn-light border mx-1"
                        onClick={() => { close(); }}
                    >
                        Salir
                    </button>
                </div>
            </div>
        ),
        onFilter: (value, record) =>
            record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) { setTimeout(() => searchInput.current?.select(), 100); }
        }
    });

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
    };
    const handleReset = (clearFilters, setSelectedKeys, confirm) => {
        clearFilters();
        setSelectedKeys([]);
        confirm();
    };
    const aux_estado = (row) => {
        let pendiente = row.pasos.find(p => p.estado === "PENDIENTE");

        return (pendiente) ? (
            <span className="me-1 text-secondary">(PENDIENTE)</span>
        ) : (
            <span className="me-1 fw-bold">(COMPLETADO)</span>
        );
    }
    const pagado = (row) => {
        return row.pagos.reduce((total, current) => (total += parseFloat(current.monto)), 0);
    }

    return (
        <Table
            size="small"
            dataSource={casos.items}
            rowKey='id'
            loading={casos.loading}
            onChange={casos.handleTableChange}
            pagination={{ ...casos.tableParams?.pagination, position: ['bottomCenter'], showSizeChanger: true }}
            scroll={{ y: 400, }}
            bordered
        >
            <Column title="*" dataIndex="id" key="buttons" width={90} className="text-center"
                render={(id, row) => (<ActionButtons item={row} />)}
            />
            <Column title="ID" dataIndex="id" key="id" align="center" className="fw-bold"
                sorter={true}
                width={100}
                render={(value) => sprintf('%04d', value)}
            />
            <Column title="Código Caso" dataIndex="codigo" key="codigo" align="center"
                sorter={true}
                width={120}
                filterDropdown={getColumnSearchProps('codigo').filterDropdown}
                onFilterDropdownOpenChange={getColumnSearchProps('codigo').onFilterDropdownOpenChange}
            />

            <Column title="Inicio" dataIndex="fecha_inicio" key="fecha_inicio"
                sorter={true}
                width={120}
                render={(value) => (<>{dayjs(value).format('DD/MM/YYYY')}</>)}
            />

            <Column title="Fin" dataIndex="fecha_fin" key="fecha_fin"
                sorter={true}
                width={120}
                render={(value) => (value) ? (<>{dayjs(value).format('DD/MM/YYYY')}</>) : (<>-</>)}
            />

            <Column title="Cliente" dataIndex="cliente" key="cliente"
                sorter={true}
                width={200}
                filterDropdown={getColumnSearchProps('cliente').filterDropdown}
                onFilterDropdownOpenChange={getColumnSearchProps('cliente').onFilterDropdownOpenChange}
                render={(value) => (<>{`${value.nombres} ${value.apellidos}`}</>)}
            />

            <Column title="Titular" dataIndex="titular" key="titular"
                sorter={true}
                width={200}
                render={(value) => <>{`${value.nombres} ${value.apellidos}`}</>}
                filterDropdown={getColumnSearchProps('titular').filterDropdown}
                onFilterDropdownOpenChange={getColumnSearchProps('titular').onFilterDropdownOpenChange}
            />
            <Column title="Junior" dataIndex="junior" key="junior"
                sorter={true}
                width={200}
                render={(value) => <>{`${value.nombres} ${value.apellidos}`}</>}
                filterDropdown={getColumnSearchProps('junior').filterDropdown}
                onFilterDropdownOpenChange={getColumnSearchProps('junior').onFilterDropdownOpenChange}
            />
            <Column title="Área" dataIndex="area" key="area"
                sorter={true}
                width={150}
                render={(value) => <>{`${value.nombre}`}</>}
                filterDropdown={getColumnSearchProps('area').filterDropdown}
                onFilterDropdownOpenChange={getColumnSearchProps('area').onFilterDropdownOpenChange}
            />
            <Column title="Trámite" dataIndex="tramite" key="tramite"
                sorter={true}
                width={200}
                render={(value) => <>{`${value.nombre}`}</>}
                filterDropdown={getColumnSearchProps('tramite').filterDropdown}
                onFilterDropdownOpenChange={getColumnSearchProps('tramite').onFilterDropdownOpenChange}
            />
            <Column title="Deuda trámites en Bs." dataIndex="monto_adeudado_tramites" key="monto_adeudado_tramites"
                align="right"
                sorter={true}
                width={100}
            />
            <Column title="Deuda Honorarios en Bs." dataIndex="monto_adeudado_honorarios" key="monto_adeudado_honorarios"
                align="right"
                sorter={true}
                width={100}
            />
            <Column title="Deuda total en Bs." dataIndex="monto_adeudado_total" key="monto_adeudado_total"
                align="right"
                sorter={true}
                width={100}
            />
            <Column title="Monto pagado en Bs." dataIndex="monto_cancelado" key="monto_cancelado"
                align="right"
                sorter={true}
                width={100}
            />
            <Column title="Estado" dataIndex="estado" key="estado"
                width={160}
                align="right"
                render={(id, row) => (
                    <>
                        {aux_estado(row)}
                        <button className="btn btn-sm btn-danger ms-1 py-0"
                            onClick={() => casos.selectItem(row)} >
                            Ver
                        </button>
                    </>
                )}
                filters={[
                    { text: 'PENDIENTE', value: 'PENDIENTE' },
                    { text: 'COMPLETADO', value: 'COMPLETADO' },
                ]}
                filterMultiple={false}
            />

            <Column title="Documentos" dataIndex="id" key="documentos"
                width={110}
                align="center"
                render={(id, row) => (
                    <button className="btn btn-sm btn-link"
                        onClick={() => documentos.showModalDocumentos(row)} >
                        Ver
                    </button>)}
            />

        </Table>
    );
}
